import { useEffect } from "react";

import BoxContainer from "@hl/base-components/lib/BoxContainer";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { useUploadManager } from "@hl/base-components/lib/upload/context";
import { Center, Loader, Stack, Text } from "@mantine/core";

import { useIsSeriesUnzipDoneQuery } from "../../queries/draft.graphql.generated";

import { useCreateCollectionState } from "./context";

export const POLL_INTERVAL_MS = 15000;

const UnzipProgress = () => {
  const {
    state: { file, zipBucketName },
  } = useUploadManager();
  const { state: draftState, dispatch } = useCreateCollectionState();

  const { data, startPolling } = useIsSeriesUnzipDoneQuery({
    variables: {
      seriesZipFolderName: zipBucketName!,
    },
    skip: !zipBucketName || draftState.unzipped,
  });

  useEffect(() => {
    startPolling(POLL_INTERVAL_MS);
  }, [startPolling]);

  useEffect(() => {
    if (data?.isSeriesUnzipDone.finishedUnzipping) {
      dispatch({
        type: "UPDATE_UNZIPPED",
        payload: {
          unzipped: data?.isSeriesUnzipDone.finishedUnzipping,
        },
      });
    }
  }, [data]);

  return (
    <BoxContainer p={32}>
      <Stack align="center" spacing={4}>
        <Text size="sm" weight={500}>
          {`Unzipping ${file?.name || "file"} `}
        </Text>
        <Text size="sm" color={TEXT_COLOR.SECONDARY}>
          This may take a few minutes
        </Text>
        <Center mt={18}>
          <Loader aria-label="loading" size={28} />
        </Center>
      </Stack>
    </BoxContainer>
  );
};

export default UnzipProgress;
